import { useEffect, useRef, useState } from "react";
import { BoxSelect, ChevronDown, Shapes } from "lucide-react";
import { SIGNS, SignMini } from "@/components/map/SignObjects";

export const ObjectsMenu = ({ mode, setMode }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const away = (e) => !ref.current?.contains(e.target) && setOpen(false);
    const esc = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", away);
    window.addEventListener("keydown", esc);
    return () => { document.removeEventListener("mousedown", away); window.removeEventListener("keydown", esc); };
  }, [open]);
  const cur = mode?.startsWith("sign:") ? mode.slice(5) : null;
  const pick = (m) => { setMode(mode === m ? null : m); setOpen(false); };
  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen((v) => !v)} data-testid="map-objects-menu-button" title="Objetos de señalización"
        className={`flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-medium transition-colors ${cur || mode === "box" || mode === "sign_line" ? "bg-amber-400 text-slate-950" : "text-slate-300 hover:bg-white/10"}`}>
        {cur ? <SignMini type={cur} size={16} /> : mode === "box" ? <BoxSelect className="w-4 h-4" /> : <Shapes className="w-4 h-4 text-amber-400" />}
        <span className="hidden xl:inline">Objetos</span><ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute left-0 top-full mt-1 w-64 bg-[#090f20]/95 backdrop-blur-md border border-white/10 rounded-xl p-1 shadow-2xl rise" data-testid="map-objects-toolbar">
          {Object.entries(SIGNS).map(([k, v]) => (
            <button key={k} data-testid={`map-add-sign-${k}`} onClick={() => pick(v.line ? "sign_line" : `sign:${k}`)}
              className={`w-full flex items-center gap-2.5 px-2.5 py-1.5 rounded-lg text-xs transition-colors ${cur === k || (v.line && mode === "sign_line") ? "bg-amber-400 text-slate-950" : "text-slate-200 hover:bg-white/10"}`}>
              <SignMini type={k} size={18} /><span className="flex-1 text-left">{v.label}</span><span className="font-mono text-[9px] opacity-60">{v.code}</span>
            </button>
          ))}
          <div className="h-px bg-white/10 my-1" />
          <button data-testid="map-box-template-button" onClick={() => pick("box")}
            className={`w-full flex items-center gap-2.5 px-2.5 py-1.5 rounded-lg text-xs transition-colors ${mode === "box" ? "bg-amber-400 text-slate-950" : "text-slate-200 hover:bg-white/10"}`}>
            <BoxSelect className="w-4 h-4" /> Guardar plantilla (recuadro)
          </button>
        </div>
      )}
    </div>
  );
};
